export default __webpack_public_path__ + "static/media/R (2).023c7956.jpg";